<template>
  <b-row>
    <b-col>
      <b-card>
        <template #header>
          <strong>搜尋條件</strong>
        </template>
        <b-row>
          <b-col lg="2" md="3">
            <b-form-group label="類型">
              <b-form-select v-model="filter.category" :options="categorylist"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="分類">
              <b-form-select v-model="filter.type" :options="typelist"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="內容">
              <b-form-input v-model="filter.content"></b-form-input>
            </b-form-group>
          </b-col> 
          <b-col lg="2" md="3">
            <b-form-group label="起始日期">
              <date-picker v-model="filter.start" valueType="format" />
            </b-form-group>
          </b-col>
          <b-col lg="2" md="3">
            <b-form-group label="結束日期">
              <date-picker v-model="filter.end" valueType="format" />
            </b-form-group>
          </b-col>
        </b-row>
        <template #footer>
          <b-button variant="danger" size="sm" class="float-right" @click="clearFilter()"> 清空 </b-button>
          <b-button variant="success" size="sm" class="float-right mr-1" @click="search()"> 查詢 </b-button>
        </template>
      </b-card>

      <b-card>
        <template #header>
          <strong>帳務資料</strong>
        </template>
        <div class="my-2 font-weight-bold d-flex justify-content-between">
          <div>
            <span class="text-primary">目前餘額 {{ $function.priceformat(total.balance) }}</span>
          </div>
          <div>
            <span class="text-primary">總計收入 {{ $function.priceformat(total.income) }}</span> / <span class="text-danger">總計支出 {{ $function.priceformat(total.expenditure) }}</span>
          </div>
        </div>
        <b-table bordered small :items="datalist" :fields="fields" :tbody-tr-class="rowClass" show-empty>
          <template #empty>
            <h2 class="text-secondary text-center m-4">無資料</h2>
          </template>
          <template #cell(index)="row">{{ row.index + 1 }}</template>
          <template #cell(date)="row">{{ $date(row.item.date).format("YYYY-MM-DD") }}</template>
          <template #cell(content)="row">【{{ row.item.type === 0 ? "收入" : "支出" }}】 {{ row.item.content }}</template>
          <template #cell(price)="row">{{ $function.priceformat(row.item.price) }}</template>
          <template #cell(balance)="row">{{ $function.priceformat(row.item.balance) }}</template>
          <template #cell(action)="row">
            <b-button variant="danger" size="sm" @click="deleteAssets(row.item.id)">刪除</b-button>
          </template>
        </b-table>
        <b-pagination v-model="pageinfo.page" :total-rows="pageinfo.count" :per-page="pageinfo.limit" align="center" @change="getAssets"></b-pagination>
      </b-card>
      <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" no-wrap> </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-tw";

export default {
  name: "",
  components: { DatePicker },
  data: () => ({
    loading: false,
    datalist: [],
    total: {
      income: 0,
      expenditure: 0,
      balance: 0,
    },
    pageinfo: {
      count: 1,
      limit: 10,
      page: 1,
      totalPage: 1,
    },
    fields: [
      { key: "index", label: "序號", class: "text-center align-middle" },
      { key: "date", label: "日期", class: "text-center align-middle" },
      { key: "category", label: "分類", class: "text-center align-middle" },
      { key: "content", label: "內容", tdClass: "align-middle", thClass: "w-50 text-center align-middle" },
      { key: "price", label: "金額", class: "text-center align-middle" },
      { key: "balance", label: "餘額", class: "text-center align-middle" },
      { key: "action", label: "操作", class: "text-center align-middle" },
    ],
    filter: {
      category: "",
      content: "",
      type: "",
      start: "",
      end: "",
    },
    categorylist: [],
    typelist: [
      { text: "全部分類", value: "" },
      { text: "收入", value: 0 },
      { text: "支出", value: 1 },
    ],
  }),
  mounted() {
    this.getCategorylist();
    this.getAssets();
  },
  methods: {
    clearFilter() {
      this.filter.category = "";
      this.filter.type = "";
      this.filter.content = "";
      this.filter.start = "";
      this.filter.end = "";
      this.search();
    },
    search() {
      this.pageinfo.page = 1;
      this.getAssets();
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.type === 1) return "table-warning";
    },
    async getCategorylist() {
      let incomelist = await this.$function.getCustomItems("AssetRecordIncomeCategory");
      let expenditurelist = await this.$function.getCustomItems("AssetRecordExpenditureCategory");
      this.categorylist = [{ value: "", text: "全部類型" }, ...incomelist.map((p) => p.content), ...expenditurelist.map((p) => p.content)];
    },
    getAssets(page = null) {
      this.loading = true;
      let params = {
        params: {
          page: page === null ? this.pageinfo.page : page,
          category: this.filter.category,
          search: this.filter.content,
          type: this.filter.type,
          start: this.filter.start,
          end: this.filter.end,
        },
      };
      this.$http.get("/asset", params).then((response) => {
        if (response.data.success) {
          this.datalist = response.data.result.datalist;
          this.pageinfo = response.data.result.pageinfo;
          this.total.income = response.data.result.totalIncome;
          this.total.expenditure = response.data.result.totalExpenditure;
          this.total.balance = response.data.result.balance;
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
        this.loading = false;
      });
    },
    async deleteAssets(id) {
      let confirm = false;
      await this.$bvModal
        .msgBoxConfirm("確認是否刪除此帳務紀錄，此動作無法還原。", {
          title: "刪除帳務紀錄",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "確認",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: true,
        })
        .then((value) => {
          confirm = value;
        });
      if (confirm === false) return;
      let params = {
        params: {
          id: id,
        },
      };
      this.$http.delete("/asset", params).then((response) => {
        if (response.data.success) {
          this.$notify({ type: "success", text: "刪除成功" });
          this.getAssets();
        } else {
          this.$notify({ type: "error", text: response.data.message });
        }
      });
    },
  },
};
</script>